import { generateClient } from 'aws-amplify/api';
import * as mutations from '../graphql/mutations';
import { PAGE_SIZE_FOR_EXPORTS } from '../services/smorg_studio_memberships';

const client = generateClient();

export const listSpaceMembershipsOperation = async (offset, pageSize) => {
  const response = await client.graphql({
    query: mutations.listSmorgStudioMemberships,
    variables: {
      offset,
      pageSize,
    },
  });
  return response.data.listSmorgStudioMemberships;
};

export const searchSpaceMembershipsOperation = async (searchString) => {
  const response = await client.graphql({
    query: mutations.listSmorgStudioMemberships,
    variables: {
      searchCriteria: { searchString },
    },
  });
  return response.data.listSmorgStudioMemberships;
};

export const membershipAdminSetExpiresAtOperation = async (
  spaceMembershipID,
  expiresAt,
) => {
  const response = await client.graphql({
    query: mutations.smorgStudioMembershipAdminSetExpiresAt,
    variables: {
      spaceMembershipID,
      expiresAt,
    },
  });
  return response.data.smorgStudioMembershipAdminSetExpiresAt;
};

export const membershipAdminChangePasswordOperation = async (
  spaceMembershipID,
  newPassword,
) => {
  const response = await client.graphql({
    query: mutations.smorgStudioMembershipAdminSetPassword,
    variables: {
      spaceMembershipID,
      cleartextPassword: newPassword,
    },
  });
  return response.data.smorgStudioMembershipAdminSetPassword;
};

export const membershipAdminChangeEmailOperation = async (
  spaceMembershipID,
  newEmailAddress,
) => {
  console.log(
    'membershipAdminChangeEmailOperation called with: ',
    spaceMembershipID,
    newEmailAddress,
  );
  const response = await client.graphql({
    query: mutations.smorgStudioMembershipAdminSetEmail,
    variables: {
      spaceMembershipID,
      newEmailAddress,
    },
  });
  console.log('membershipAdminChangeEmailOperation response: ', response);
  return response.data.smorgStudioMembershipAdminSetEmail;
};

export const membershipAdminDeleteUserOperation = async (spaceMembershipID) => {
  const response = await client.graphql({
    query: mutations.smorgStudioMembershipAdminDeleteUser,
    variables: {
      spaceMembershipID,
    },
  });
  return response.data.smorgStudioMembershipAdminDeleteUser;
};

export const fetchAllSmorgStudioMembershipsForExportOperation = async () => {
  let offset = 0;
  let lastPage = [];
  const allMemberships = [];
  do {
    // eslint-disable-next-line no-await-in-loop
    lastPage = await listSpaceMembershipsOperation(
      offset,
      PAGE_SIZE_FOR_EXPORTS,
    );
    offset += PAGE_SIZE_FOR_EXPORTS;
    allMemberships.push(...lastPage);
  } while (lastPage.length === PAGE_SIZE_FOR_EXPORTS);
  return allMemberships;
};
